import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import Lottie from 'lottie-react';
import styled from 'styled-components';
import DiscountLoadingJson from 'assets/ver2/lotties/offer-validating.json';
import {
  DISCOUNT_LOADING_MIN_VISIBLE_MS,
  useMinVisibleFlag,
} from '../../hooks/useMinVisibleFlag';

const DiscountLoading = ({
  isOpen = false,
  minVisibleMs = DISCOUNT_LOADING_MIN_VISIBLE_MS,
}) => {
  const isVisible = useMinVisibleFlag(isOpen, minVisibleMs);

  if (!isVisible) return null;

  return (
    <>
      <DiscountLoadingBackdrop />
      <DiscountLoadingSpinnerWrap role="status" aria-label="Applying discount">
        <FormImage>
          <Lottie
            animationData={DiscountLoadingJson}
            loop={true}
            style={{
              width: '160px',
              height: '143px',
            }}
          />
        </FormImage>
      </DiscountLoadingSpinnerWrap>
    </>
  );
};

const DiscountLoadingBackdrop = styled.div`
  position: absolute;
  width: 100%;
  height: 100dvh;
  background: #212121;
  opacity: 0.25;
  z-index: 10000;
  top: 0;
  left: 0;
`;

const DiscountLoadingSpinnerWrap = styled.div`
  position: absolute;
  z-index: 10001;
  padding: 0px;
  display: grid;
  justify-items: center;
  background: transparent;
  border-radius: 8px;
  top: calc(50% - 91.5px);
  left: 16px;
  width: calc(100% - 32px);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    top: calc(50% - 91.5px);
    left: calc(50% - 200px);
    width: 436px;
  }

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    top: calc(50% - 91.5px);
  }
`;

const FormImage = styled.div`
  padding: 20px;
  background-color: #ffffff;
  border-radius: 20px;
`;

export default DiscountLoading;
